import { render, staticRenderFns } from "./feedBackUpload.vue?vue&type=template&id=156740be&scoped=true"
import script from "./feedBackUpload.vue?vue&type=script&lang=js"
export * from "./feedBackUpload.vue?vue&type=script&lang=js"
import style0 from "./feedBackUpload.vue?vue&type=style&index=0&id=156740be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156740be",
  null
  
)

export default component.exports